/**
 * ai-assistant capability keys — the EXACT server capability strings
 * (server/src/modules/ai-assistant/{routes,ai-assistant.module}.js). useCan / nav gating /
 * ProtectedRoute all key off these. The server re-checks every request; these only hide/disable UI
 * (never the trust boundary).
 *
 *   POST /assistant/sessions                 ai.assistant.query
 *   POST /assistant/sessions/:id/messages    ai.assistant.query
 *   GET  /assistant/instructions             ai.assistant.query
 *   PUT  /assistant/instructions             ai.assistant.instructions.manage   (lab-Admin only)
 */
export const AI_CAPS = {
  /** Open a session, ask the helpdesk, and read the active instructions.md. */
  query: "ai.assistant.query",
  /** Publish a new version of the lab's instructions.md (lab-Admin only, append-only versioned). */
  instructionsManage: "ai.assistant.instructions.manage",
} as const;

export type AiAssistantCapability = (typeof AI_CAPS)[keyof typeof AI_CAPS];

/** The module-level gate: the minimum to reach any ai-assistant screen. */
export const MODULE_CAPS = [AI_CAPS.query] as const;
